import 'es6-promise/auto';
import Vue from 'vue';
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'
import App from '@src/App';
import router from '@src/router';
import store from '@src/store';
import * as System from '@src/utils/system';
import VueLazyload from 'vue-lazyload';
import i18n, { loadLanguageAsync } from './lang'
import Toast from '@src/components/toast'
import Tab from 'vant/lib/tab'
import Tabs from 'vant/lib/tabs'
import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'
import Dialog from 'vant/lib/dialog'
import 'vant/lib/dialog/style'
import List from 'vant/lib/list'
import Popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import LazyImage from '@src/components/lazy-image';
import "babel-polyfill"
import { setRegion } from './utils/getRegion.js'
import util from './utils/util'

window.__page__t2 = new Date().getTime();
let t21 = (window.__page__t2 - window.__page__t1) / 1000; //超过2s就当弱网
let netType = (JsBridge.getNetworkType && JsBridge.getNetworkType()) || '';

// set the region from queryString,it is used as the global variable
setRegion(util.getQueryString('region'))
router.beforeEach((to, form, next) => {
  loadLanguageAsync().then(() => next())
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
Vue.prototype.$timerStart = window.timerStart;
// Vue.use(OpPopup);  //勿随意挪动该处的位置.
Vue.use(Toast)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Dialog)
Vue.use(Popup)
Vue.use(List)
Vue.use(VueLazyload, {
  preLoad: 1.8,
  observer: true,
  attempt: 2,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'touchmove'],
  filter: {
    addWebp(listener, options) {
      if (!options.supportWebp) {
        return;
      }
      if (/gif/.test(listener.src)) {
        return;
      }
      const isCdn = /actimg.heytapimg.com/;
      if (isCdn.test(listener.src)) {
        let curWidth = document.body.clientWidth;
        if (['unavailable', '2g', '3g'].indexOf(netType) > -1 || t21 > 2) { //弱网
          if (/webp/.test(listener.src)) {
            var matchReg = /\.w(\d+)-h0-q\d+\.webp$/;
            if (matchReg.test(listener.src)) {
              var matchArr = listener.src.match(matchReg);
              let width = matchArr[1];
              if (width > curWidth) {
                listener.src = listener.src.replace(matchReg, `.w${curWidth}-h0-q75.webp`);
              }
            }
          } else {
            listener.src += '.webp';
          }
        } else { //网络情况较好的时候
          if (!/webp/.test(listener.src)) {
            listener.src += '.webp';
          }
        }
      }
    }
  }

});
Vue.component('LazyImage', LazyImage);
Vue.config.productionTip = System.isDebug; // 生产日志
Vue.config.devtools = System.isDebug; // 支持debug工具
Vue.config.performance = System.isDebug; // 在浏览器开发工具中启用对组件初始化，渲染和打补丁的性能追踪
ActStat.reportError();
if (process.env.NODE_ENV !== 'production') { //调试工具
  const VConsole = require('vconsole');
  new VConsole();
}

new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
  // template: '<App/>',
  // components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js